import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';

const CardFacturationElectronique = ({ RegimeTVA }) => {
    // On vérifie si l'objet existe et si retourField n'est pas 0
    if (!RegimeTVA || RegimeTVA.retourField === 0) {
        return null;
    }

    // On extrait les noms exacts vus dans ta console
    const { retourField, messageField } = RegimeTVA;

    const renderStatus = () => {
        switch (retourField) {
            case 1: // Message OK FE
                return (
                    <div className="info text-center">
                        <i className="fa fa-circle-check valide fa-lg me-2" title="info"></i>
                        {messageField}
                    </div>
                );
            case 11: // Message info éxonéré TVA
                return (
                    <div className="info text-center">
                        <i className="fa fa-circle-info fa-lg me-2" title="info"></i>
                        {messageField}
                    </div>
                );
            case 2: // Message danger
                return (
                    <div className="danger text-center">
                        <i className="fa fa-exclamation-triangle fa-lg me-2" title="danger"></i>
                        {messageField}
                    </div>
                );
            case 3: // Message erreur
                return (
                    <div className="erreur text-center">
                        <i className="fa-solid fa-circle-xmark fa-lg me-2" title="erreur"></i>
                        {messageField}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <Card Titre={CardFacturationElectronique.titleName}>
            <div className="card-text mb-3">
                {renderStatus()}
            </div>
            <div className="d-flex justify-content-center">
                <Link to="/MesInformations/InfoFE" className="btn btn-outline-primary mt-2 w-50">
                    Détails
                </Link>
            </div>
        </Card>
    );
};

CardFacturationElectronique.displayName = 'CardFacturationElectronique';
CardFacturationElectronique.titleName = 'Facturation électronique';
CardFacturationElectronique.requiredProps = ['RegimeTVA'];

function mapStateToProps({
    ProStore: {
        Pro: { RegimeTVA },
    },
}) {
    return {
        RegimeTVA,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardFacturationElectronique));


// WEBPACK FOOTER //
// ./src/components/MesInfos/CardFacturationElectronique.js